import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Card,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const TopChecksByDuration = (props) => {
  const { classes, data = [] } = props;
  const { t } = useTranslation();

  const [checks, setChecks] = useState([]);

  useEffect(() => {
    setChecks(
      (data || []).map((val) => ({
        label: val["companyName"],
        text: t("labels.dashboard.topChecksByDuration.secondaryLine", {
          checkType: val["check_type"],
          timeTaken: val["timeTaken"]
        }),
      }))
    );
  }, [data]);

  return (
    <Card
      className={classes.cardContainer}
      variant="outlined"
      elevation={0}
      style={{ height: 300, overflowY: "scroll" }}
    >
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "1.31rem",
          color: "#464646",
          paddingLeft: 5,
        }}
      >
        {t("labels.dashboard.topChecksByDuration.title")}
      </Typography>
      <List>
        {(checks || []).map((val, index) => {
          return (
            <ListItem key={index} className={classes.latestChecksItem}>
              <ListItemText primary={val.label} secondary={val.text} />
            </ListItem>
          );
        })}

        {checks.length < 1 && (
          <Typography style={{ textAlign: "center" }}>
            {t("labels.dashboard.common.noDataMessage")}
          </Typography>
        )}
      </List>
    </Card>
  );
};

export default TopChecksByDuration;
